import { render, staticRenderFns } from "./DataPresentation-Ex.vue?vue&type=template&id=1247b7c9&scoped=true&"
import script from "./DataPresentation-Ex.vue?vue&type=script&lang=js&"
export * from "./DataPresentation-Ex.vue?vue&type=script&lang=js&"
import style0 from "./DataPresentation-Ex.vue?vue&type=style&index=0&id=1247b7c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247b7c9",
  null
  
)

export default component.exports